import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=6c907023&scoped=true&"
import script from "./ProductDescription.vue?vue&type=script&lang=js&"
export * from "./ProductDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c907023",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c907023')) {
      api.createRecord('6c907023', component.options)
    } else {
      api.reload('6c907023', component.options)
    }
    module.hot.accept("./ProductDescription.vue?vue&type=template&id=6c907023&scoped=true&", function () {
      api.rerender('6c907023', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductDescription.vue"
export default component.exports